import React from "react";

interface TicketIconProps {
  style?: React.CSSProperties;
  fill?: string;
}
const SidebarTicketIcon: React.FC<TicketIconProps> = ({ style, fill }) => {
  return (
    <svg
      className="w-[25px] h-[25px] p-[2px] rounded"
      style={style}
      fill={fill}
      height="800px"
      width="800px"
      version="1.1"
      id="Layer_1"
      viewBox="0 0 460 460"
    >
      {" "}
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />{" "}
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />{" "}
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M431.35,0H28.652C12.996,0,0.305,12.691,0.305,28.346v403.307C0.305,447.309,12.996,460,28.652,460H431.35 c15.655,0,28.346-12.691,28.346-28.346V28.346C459.697,12.691,447.005,0,431.35,0z M163.479,30.875c14.359,0,26,11.641,26,26 s-11.641,26-26,26c-14.359,0-26-11.641-26-26S149.12,30.875,163.479,30.875z M84.628,30.875c14.359,0,26,11.641,26,26 s-11.641,26-26,26s-26-11.641-26-26S70.269,30.875,84.628,30.875z M261.642,399.685H71.839c-13.808,0-25-11.193-25-25 s11.192-25,25-25h189.803c13.808,0,25,11.193,25,25C286.642,388.491,275.45,399.685,261.642,399.685z M262.808,289.342H73.005 c-13.808,0-25-11.193-25-25s11.192-25,25-25h189.803c13.808,0,25,11.193,25,25C287.808,278.148,276.616,289.342,262.808,289.342z M378.056,179H73.709c-13.807,0-25-11.193-25-25s11.193-25,25-25h304.347c13.808,0,25,11.193,25,25S391.864,179,378.056,179z" />{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};
export default SidebarTicketIcon;



